<template>
  <div class="user-container">
    <el-card>
      <div slot="header">
        <span>用户激活</span>
      </div>

      <!-- 搜索区域 -->
      <div class="search-box" style="margin-bottom: 20px;">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="用户ID">
            <el-input 
              v-model="searchForm.userId" 
              placeholder="请输入用户ID" 
              clearable
              style="width: 200px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="用户名">
            <el-input 
              v-model="searchForm.username" 
              placeholder="请输入用户名" 
              clearable
              style="width: 200px;"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
            <el-button @click="handleReset" icon="el-icon-refresh-left">重置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 用户表格 -->
      <el-table :data="tableData" v-loading="loading" style="width: 100%" border>
        <el-table-column prop="userid" label="ID" width="100"></el-table-column>
        <el-table-column prop="phone" label="用户名"></el-table-column>
        <el-table-column prop="wechat" label="微信名"></el-table-column>
        <el-table-column prop="password" label="密码">
          <template slot-scope="scope">
            <el-input class="password_show" placeholder="请输入密码" :value="scope.row.password" show-password></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="balance" label="余额" sortable></el-table-column>
        <el-table-column prop="major_price" label="专业课价格" sortable></el-table-column>
        <el-table-column prop="public_price" label="公共课价格" sortable></el-table-column>
        <!-- <el-table-column prop="verify" label="是否认证"></el-table-column>
        <el-table-column prop="verify" label="是否认证" width="100" :filters="[{ text: '是', value: 1 }, { text: '否', value: 0 }]" :filter-method="filterTag" filter-placement="bottom-end">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.verify === 1 ? 'primary' : 'success'"
              disable-transitions>{{scope.row.verify === 1 ? '是' : '否'}}</el-tag>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-edit" circle @click="handleEdit(scope.row)"></el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页（可选） -->
      <div class="pagination" style="margin-top: 20px; text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="prev, pager, next, total, sizes"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <!-- 编辑用户信息弹窗 -->
    <el-dialog title="激活用户" :visible.sync="editDialogVisible">
      <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="120px">
        <el-form-item label="ID" prop="userid">
          <el-input v-model="editForm.userid" disabled></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="phone">
          <el-input v-model="editForm.phone"></el-input>
        </el-form-item>
        <el-form-item label="微信名" prop="wechat">
          <el-input v-model="editForm.wechat"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="editForm.password"></el-input>
        </el-form-item>
        <el-form-item label="余额" prop="balance">
            <el-input-number
            v-model="editForm.balance"
            :precision="2"
            :min="0"
            :step="1"
            placeholder="请输入用户余额">
          </el-input-number>
          <!-- <el-input v-model="editForm.balance"></el-input> -->
        </el-form-item>
        <el-form-item label="专业课价格" prop="major_price">
            <el-input-number
            v-model="editForm.major_price"
            :precision="2"
            :min="0"
            :step="0.5"
            placeholder="请输入专业课价格">
          </el-input-number>
          <!-- <el-input v-model="editForm.major_price"></el-input> -->
        </el-form-item>
        <el-form-item label="公共课价格" prop="public_price">
                      <el-input-number
            v-model="editForm.public_price"
            :precision="2"
            :min="0"
            :step="0.5"
            placeholder="请输入公共课价格">
          </el-input-number>
          <!-- <el-input v-model="editForm.public_price"></el-input> -->
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Info',
  data() {
    return {
      loading: false,
      tableData: [],
      // 分页相关（暂不启用）
      page: 1,
      pageSize: 10,
      total: 0,

      // 编辑弹窗
      editDialogVisible: false,
      editForm: {
        userid: '',
        phone: '',
        password: '',
        wechat: '',
        balance: 0.00,
        major_price: 0.00,
        public_price: 0.00,
        verify: 0
      },
      editRules: {
        phone: [{ required: true, message: '请输入用户名', trigger: 'blur'}],
        password: [{ required: true, message: '请输入密码', trigger: 'blur'}, { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }],
        balance: [{ required: true, message: '请输入用户余额', trigger: 'blur'}],
        major_price: [{ required: true, message: '请输入专业课价格', trigger: 'blur'}],
        public_price: [{ required: true, message: '请输入公共课价格', trigger: 'blur'}],
        public_price: [{ required: true, message: '请输入公共课价格', trigger: 'blur'}],
      },

      currentEditUser: null, // 用于临时保存当前编辑的用户

      // 搜索表单
      searchForm: {
        userId: '',
        username: ''
      }
    }
  },
  filters: {
    formatDate(date) {
      if (!date) return ''
      const d = new Date(date)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
    }
  },
  created() {
    this.fetchUserList()
  },
  methods: {

    async fetchUserList() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          verify: 0,
          userId: this.searchForm.userId || undefined,
          username: this.searchForm.username || undefined
        };
        const {data: res}= await this.$http.get('get_user_list', {params});
        this.tableData = res.data
        this.total = res.total
      } catch (error) {
        this.$message.error('获取待激活用户列表失败')
        console.error(error)
      } finally {
        this.loading = false
      }
    },

    // 编辑用户
    handleEdit(row) {
      this.currentEditUser = { ...row }
      this.editForm = { ...row }
      this.editDialogVisible = true
    },

    
    async handleDelete(row) {
      try {
        const {data: res}= await this.$http.post('delete_user', row);
        if (res.code == 200){
          this.$message.success('用户删除成功')
          this.fetchUserList() // 刷新列表
        } else{
          this.$message.error('删除失败')
        }
        this.editDialogVisible = false
      } catch (error) {
        this.$message.error('删除失败')
      }
    },

    // 搜索
    handleSearch() {
      this.page = 1; // 搜索时重置到第一页
      this.fetchUserList();
    },

    // 重置搜索条件
    handleReset() {
      this.searchForm = {
        userId: '',
        username: ''
      };
      this.page = 1;
      this.fetchUserList();
    },

    submitEdit() {
      this.$refs.editFormRef.validate(async valid => {
        if (!valid) return
        try {
          const {data: res}= await this.$http.post('activate_user', this.editForm);
          if (res.code == 200){
            this.$message.success('用户信息更新成功')
            this.fetchUserList() // 刷新列表
          } else{
            this.$message.error('更新失败')
          }
          this.editDialogVisible = false
        } catch (error) {
          this.$message.error('更新失败')
        }
      })
    },

    filterTag(value, row) {
      return row.verify === value;
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.fetchUserList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchUserList();
    }
  }
}
</script>

<style lang="less">
.user-container {
  padding: 20px;
}

.password_show {
  .el-input__inner {
    border: none;
    background-color: rgba(255, 255, 255, 0);
  }
}
</style>